<div class="side-panel">
  <div class="groups" cdkDropListGroup>
    <div class="d-flex w-100 justify-content-between">
      <div class="d-flex">
        <nmfta-icon name="grid_view" class="me-2"></nmfta-icon>
        <h3>{{ 'HOME.CUSTOMIZE_TILES' | translate }}</h3>
        <nmfta-icon name="info " class="info-button ms-3"></nmfta-icon>
      </div>
      <nmfta-button
        styleType="icon"
        iconName="close"
        color="error"
        [blackText]="true"
        (buttonClick)="close()"
      ></nmfta-button>
    </div>
    <h5>{{ 'HOME.PINNED_TILES' | translate }}</h5>
    <div
      cdkDropList
      id="pinned"
      [cdkDropListData]="pinned()"
      class="tiles-list pb-4"
      (cdkDropListDropped)="drop($event)">
      @for (tile of pinned(); track tile; let idx = $index) {
        <div class="tile-item" cdkDrag>
          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          <div class="d-flex">
            <img
              class="me-2"
              [src]="'./assets/icons/material-icons/' + getIcon(tile.tileType) + '-dark.svg'"
              alt="tile icon" />
            {{ tile.name }}
          </div>
          <div class="d-flex">
            <img
              [src]="'./assets/icons/material-icons/pin.svg'"
              class="pin"
              tabindex="0"
              alt="tile icon"
              (click)="unpinItem(idx)"
              (keydown)="handleKeydown($event, idx, 'unpin')" />
            <img
              class="drag-handle ms-2"
              cdkDragHandle
              [src]="'./assets/icons/material-icons/drag.svg'"
              alt="tile icon" />
          </div>
        </div>
      }
    </div>
    <h5>{{ 'HOME.UNPINNED_TILES' | translate }}</h5>
    <div
      cdkDropList
      id="unpinned"
      [cdkDropListData]="unpinned()"
      class="tiles-list"
      (cdkDropListDropped)="drop($event)">
      @for (tile of unpinned(); track tile; let idx = $index) {
        <div class="tile-item" cdkDrag>
          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          <div class="d-flex">
            <img
              class="me-2"
              [src]="'./assets/icons/material-icons/' + getIcon(tile.tileType) + '-dark.svg'"
              alt="tile icon" />
            {{ tile.name }}
          </div>
          <div class="d-flex">
            <img
              [src]="'./assets/icons/material-icons/unpin.svg'"
              class="pin"
              tabindex="0"
              alt="tile icon"
              (click)="pinItem(idx)"
              (keydown)="handleKeydown($event, idx, 'pin')" />
            <img
              class="drag-handle ms-2"
              cdkDragHandle
              [src]="'./assets/icons/material-icons/drag.svg'"
              alt="tile icon" />
          </div>
        </div>
      }
    </div>
  </div>
</div>
